import moment from "moment";

export function defaultListDateRange(): { startDate: Date; endDate: Date } {
	const now = new Date();
	return {
		startDate: new Date(now.getFullYear(), now.getMonth() - 3, 1),
		endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
	};
}

export function isWithinListDateFilter(
	value: string | Date | null | undefined,
	enabled: boolean,
	startDate: Date,
	endDate: Date,
): boolean {
	if (!enabled) return true;
	if (!value) return false;

	const date = moment(value);
	if (!date.isValid()) return false;

	return date.isSameOrAfter(moment(startDate).startOf("day")) && date.isSameOrBefore(moment(endDate).endOf("day"));
}
